/* global G */
import { forwardRef, useRef, useState, useCallback, useContext, useLayoutEffect } from 'react'
import { Grid, IconButton } from '@mui/material'
import { useMemoRef } from '@platform/react/hook'
import ApplicationContext from '@platform/react/context/application'
import BigPreview from 'ui/Element/Attachment/Big'
import ScrollPane from 'ui/Element/Attachment/Carousel'
import Icon from 'ui/Element/Icon'

const scrollIntoView = component => component.scrollIntoView({
  inline: 'center',
  block: 'center',
  behavior: 'smooth',
})

const ScrollButton = useMemoRef(({ onClick, icon }) => (
  <Grid item container xs={1} justifyContent={'center'}>
    <IconButton onClick={onClick} size="large">
      <Icon source={icon}/>
    </IconButton>
  </Grid>
), [])

const AttachmentPane = forwardRef((props, ref) => {
  const { eventBus } = useContext(ApplicationContext)
  const { data } = props
  const [focus, setFocus] = useState(10)
  const scrollPane = useRef()
  const focusRef = useRef(focus)

  useLayoutEffect(() => {
    scrollPane.current.children[focus] && ((el, key) => {
      eventBus.dispatch(
        eventBus.type(G.ATTACHMENT, G.DONE, key), {
          url: el.querySelector('img').src,
        },
      )
      scrollIntoView(el)
    })(scrollPane.current.children[focus], data[focus].key)
  }, [focus])

  const scrollTo = useCallback(dir => useCallback(() => {
    focusRef.current += dir
    const next = focusRef.current
    const canFocus = next <= data.length - 1 && next >= 0
    canFocus && setFocus(next)
  }, []), [])
  const onClick = useCallback(key => useCallback(() => {
    focusRef.current = key
    setFocus(key)
  }, []), [])

  return (
    <Grid item container
      ref={ref}
      xs={12}
      md={12}
      component={'section'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <ScrollButton onClick={scrollTo(-1)} icon={'arrow-left'} />
      <BigPreview attachment={data[focus]} md={10} />
      <ScrollButton onClick={scrollTo(1)} icon={'arrow-right'} />
      <ScrollButton onClick={scrollTo(-1)} icon={'caret-left'} />
      <ScrollPane {...props}
        ref={scrollPane} focus={focus} onClick={onClick} onDone={scrollIntoView}
      />
      <ScrollButton onClick={scrollTo(1)} icon={'caret-right'} />
    </Grid>
  )
})

export default useMemoRef(AttachmentPane, [])
